<template>
  <div>
    <h3>审核产品信息</h3>
    <div v-for="(item, index) in listForm" :key="index" class="outside-box">
      <div class="bill-box">
        <div class="bill-label">寻样单信息:</div>
        <ApplySample
          ref="sampleDialog"
          :isDisabled="true"
          :isDemandBrand="true"
          :isInput="false"
          :listData="item"
        />
      </div>
      <div class="bill-box">
        <div class="bill-label">审核意见:</div>
        <el-form
          ref="confirmInfoForm"
          style="width: 100%; margin-left: -45px;"
          :model="item.list[0]"
          label-width="100px"
          size="mini"
          inline
          :rules="rules"
        >
          <el-form-item label="审核结果" prop="checkStatus">
            <DictSelect
              type="cml_sample_checkstatus"
              :value="item.list[0].checkStatus"
              @change-emit="checkStatusChange($event, index)"
            />
          </el-form-item>
          <span v-if="item.list[0].checkStatus === 'PASS'">
            <el-form-item label="要求到样时间" prop="askArrivalTimeVerify">
              <el-date-picker
                v-model="item.list[0].askArrivalTimeVerify"
                type="datetime"
                placeholder="选择时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="expireTimeOption"
              />
            </el-form-item>
            <el-form-item label="给供应商留言" prop="forSupplierRemark">
              <el-input
                style="width: 300px"
                type="textarea"
                placeholder="请输入内容"
                v-model="item.list[0].forSupplierRemark"
                maxlength="100"
                size="mini"
                show-word-limit
              />
            </el-form-item>
          </span>
          <span v-if="item.list[0].checkStatus === 'NO_PASS'">
            <el-form-item label="理由" prop="checkRemark">
              <el-input
                style="width: 300px"
                type="textarea"
                placeholder="请输入内容"
                v-model="item.list[0].checkRemark"
                maxlength="30"
                size="mini"
                show-word-limit
              />
            </el-form-item>
          </span>
        </el-form>
      </div>
    </div>
    <div class="bill-box">
      <div class="bill-label"></div>
      <div class="btns">
        <el-button type="primary" @click="save" :loading="saveLoading">提交</el-button>
        <el-button @click="cancelBtn">取消</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import DictSelect from '@/components/DictSelect';
import ApplySample from '@/components/ApplySample';
import { cloneDeep } from 'lodash';
import dayjs from 'dayjs';
export default {
  name: 'Bill',
  components: { DictSelect, ApplySample },
  props: {
    removeTab: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      listForm: [],
      saveLoading: false,
      rules: {
        checkStatus: [
          { required: true, message: '请选择审核结果', trigger: 'change' },
        ],
        checkRemark: [
          { required: true, message: '请输入理由', trigger: 'blur' },
        ],
      },
      expireTimeOption:  {  //验证时间范围
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
    };
  },
  mounted() {},
  methods: {
    getListForm(val) {
      this.listForm = cloneDeep(val);
      this.clearConfirmInfoForm();
    },
    checkStatusChange(val, index) {
      // 清空审核数据
      const item = this.listForm[index].list[0];
      this.$set(item, 'checkStatus', val);
      this.$set(item, 'askArrivalTimeVerify', '');
      this.$set(item, 'forSupplierRemark', '');
      this.$set(item, 'checkRemark', '');
      this.$refs.confirmInfoForm[index].clearValidate();
      // 设置默认值
      if (val === 'PASS') {
        this.$nextTick(() => {
          const { askArrivalTime, specialRemark } = item;
          this.$set(item, 'askArrivalTimeVerify', askArrivalTime);
          this.$set(item, 'forSupplierRemark', specialRemark);
        });
      }
    },
    // 清空form表单
    clearConfirmInfoForm() {
      this.$nextTick(() => {
        this.$refs.confirmInfoForm.map(el => {
          el.resetFields();
        });
      });
    },
    checkFormValid() {
      let formValid = []; // 正确数据
      this.$refs.confirmInfoForm.map(item => {
        item.validate(valid => {
          formValid.push(valid)
        });
      });
      return formValid.every(Boolean);
    },
    save() {
      // form校验
      if (!this.checkFormValid()) {
        return;
      }
      // 校验要求到样时间
      let errArr = this.listForm.filter(item => dayjs(dayjs().format('YYYY-MM-DD HH:mm:ss')).diff(dayjs(item.list[0].askArrivalTimeVerify)) > 0);
      if(errArr.length > 0) {
        this.$message.error(`产品名称【${errArr[0].list[0].productName}】的要求到样时间不能早于当前时间`);
        return;
      }
      const params = [ ...this.listForm ].reduce((prev, cur) => {
        prev.push(
          {
            ...cur.list[0],
            askArrivalTime: cur.list[0].askArrivalTimeVerify
          }
        );
        return prev;
      }, []);
      this.saveLoading = true;
      this.$http.sample
        .batchAddCheckInfo(params)
        .then(() => {
          this.$message.success('操作成功');
          this.removeTab('bill');
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    cancelBtn() {
      this.removeTab('bill');
    }
  },
};
</script>

<style lang="less" scoped>
h3 {
  text-align: center;
}
.bill-box {
  display: flex;
  padding: 10px;
  .product-info-box {
    position: relative;
    // height: 200px;
  }
  .bill-label {
    font-weight: bold;
    width: 190px;
  }
  .btns {
    width: 100%;
    margin-left: -180px;
    text-align: center;
  }
}
.outside-box {
  border-bottom: 1px dashed #ccc;
}
</style>
